import _ from '@/utils/lodash-optimized'
import React from 'react'

import { USStateCodes } from '../../../../../../lib/Codes'
import {
  bindTargetMixin,
  CancelButton,
  CheckboxInput,
  MaskedTextInput,
  SaveButton,
  SelectInput,
  TextInput,
  Validators
} from '../../../../../shared/FormBuilder'
import { Paper } from '../../../../../shared/NarusMaterial'

class AttorneyForm extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  isEmptyForm () {
    return _.isEmpty(this.state.value)
  }

  getValue () {
    return { ...this.state.value }
  }

  handleSubmit () {
    const { onSubmit } = this.props
    this.setState({ isSubmitting: true })
    onSubmit(this.getValue())
  }

  render () {
    const { onCancel } = this.props

    const disableSave = this.isEmptyForm()

    return (

      <form
        onKeyDown={this.props.onKeyDown}
        className='margin-top margin-bottom'
      >
        <Paper>
          <div className='row'>
            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='Last Name'
                name='lastName'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='First Name'
                name='firstName'
              />
            </div>

            <div className='col-xs-12 col-sm-12 col-md-4'>
              <TextInput
                label='Firm'
                name='firm'
              />
            </div>

            <div className='col-xs-3 margin-top'>
              <CheckboxInput
                label='Living Will'
                name='livingwill'
              />
            </div>

            <div className='col-xs-3 margin-top'>
              <CheckboxInput
                label='Advanced Directive'
                name='advancedDirective'
              />
            </div>

            <div className='col-xs-3 margin-top'>
              <CheckboxInput
                label='DNR'
                name='dnr'
              />
            </div>

            <div className='col-xs-3 margin-top'>
              <CheckboxInput
                label='POST / POLST'
                name='post'
              />
            </div>

            <div className='col-xs-12 col-sm-6'>
              <TextInput
                label='Address 1'
                name='address1'
              />
            </div>

            <div className='col-xs-12 col-sm-6'>
              <TextInput
                label='Address 2'
                name='address2'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='City'
                name='city'
              />
            </div>

            <div className='bottom-xs col-xs-12 col-sm-6 col-md-4'>
              <SelectInput
                name='state'
                options={USStateCodes}
                label='State'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4'>
              <MaskedTextInput
                mask='11111'
                label='Zip'
                name='zip'
              />
            </div>
            <div className='col-xs-12 col-sm-6'>
              <MaskedTextInput
                label='Phone Number'
                name='phone'
                mask='111.111.1111'
              />
            </div>
            <div className='col-xs-12 col-sm-6'>
              <TextInput
                label='Email'
                name='email'
                validators={[ Validators.email() ]}
              />
            </div>
          </div>

          <div className='row end-xs'>
            <div className='col-xs-12'>
              <CancelButton
                noGlobal
                onClick={onCancel}
              />
              <SaveButton
                disabled={disableSave || this.state.isSubmitting}
                onClick={this.handleSubmit}
              />
            </div>
          </div>
        </Paper>
      </form>
    )
  }
}

export default AttorneyForm
